import Vue from 'vue'
import Router from 'vue-router'

import index from '@/pages/index'
import forecast from '@/pages/forecast/index'
// import analytics from '@/pages/forecast/analytics'
import map from '@/pages/map/index'
import rank from '@/pages/rank/index'
import calculate from '@/pages/calculate/index'
import about from '@/pages/about'
import publicity from '@/pages/publicity/index'


Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: index,
        },
        {
            path: '/index',
            name: 'index',
            component: index,
        },
        {
            path: '/forecast/:query_type',
            name: 'forecast',
            component: forecast,
        },
        {
            path: '/map/:data_type',
            name: 'map',
            component: map,
            children: [{
                path: ':provience',
                name: 'map-provience',
                component: map
            }]
        },
        {
            path: '/rank/:data_type',
            name: 'rank',
            component: rank,
        },
        {
            path: '/calculate',
            name: 'calculate',
            component: calculate,
        },
        {
            path: '/about',
            name: 'about',
            component: about
        },
        // 竞赛图
        {
            path: '/publicity-:data_type-:frequency-:start_year-:time_type-:mode',
            name: 'publicity',
            component: publicity
        },
        {
            path: '/publicity-:data_type-:frequency-:start_year-:time_type',
            name: 'publicity',
            component: publicity
        },
        {
            path: '/publicity-:data_type-:frequency-:start_year',
            name: 'publicity',
            component: publicity
        },
        {
            path: '/publicity-:data_type-:frequency',
            name: 'publicity',
            component: publicity
        },
        {
            path: '/publicity-:data_type',
            name: 'publicity',
            component: publicity
        },
        {
            path: '/publicity',
            name: 'publicity',
            component: publicity
        }

    ],
    linkActiveClass: 'deCur'
})
